module.exports = __webpack_public_path__ + "img/buyCompanyAct.c4df7755.png";